export default __webpack_public_path__ + "static/media/Teder_Logo_Transparent.265f0319.png";